import { getApi } from './api_instance'

export const fetchProjects = async (
  { page, pageSize, filterData = null, searchQuery = '' },
  dispatch
) => {
  try {
    filterData = JSON.stringify(filterData)
    return await getApi({
      apiUrl: `/projects/api/getAllholdingsProjects?filterData=${filterData}&page=${page}&pageSize=${pageSize}&searchQuery=${searchQuery}`,
      dispatch
    })
  } catch (error) {
    throw error
  }
}
